import {
  TUserTable,
  UserRole,
  UserStatus,
  UserRolePermission,
} from '@src/types/settings.ts';
import { TOption } from '@src/types';

export const roleCheckboxData: TOption[] = [
  { label: 'Entry Support', value: UserRole.SUPPORT_ENTRY },
  { label: 'Junior Support', value: UserRole.SUPPORT_JUNIOR },
  { label: 'Senior Support', value: UserRole.SUPPORT_SENIOR },
  { label: 'Marketing Content', value: UserRole.MARKETING_CONTENT },
  { label: 'Marketing Data', value: UserRole.MARKETING_DATA },
  { label: 'Management', value: UserRole.ADMIN },
];

export const rolePermissionCheckboxData: TOption[] = [
  {
    label: 'View Trader Basic',
    value: UserRolePermission.VIEW_TRADER_BASIC,
  },
  {
    label: 'View Trader Sensitive',
    value: UserRolePermission.VIEW_TRADER_SENSITIVE,
  },
  {
    label: 'Edit Trader Profile',
    value: UserRolePermission.EDIT_TRADER_PROFILE,
  },
  {
    label: 'Delete Trader',
    value: UserRolePermission.DELETE_TRADER,
  },
  {
    label: 'Disable Trader',
    value: UserRolePermission.DISABLE_TRADER,
  },
  {
    label: 'Flag Trader',
    value: UserRolePermission.FLAG_TRADER,
  },
  {
    label: 'View Account Basic',
    value: UserRolePermission.VIEW_ACCOUNT_BASIC,
  },
  {
    label: 'View Account Full',
    value: UserRolePermission.VIEW_ACCOUNT_FULL,
  },
  {
    label: 'Edit Account',
    value: UserRolePermission.EDIT_ACCOUNT,
  },
  {
    label: 'Close Account',
    value: UserRolePermission.CLOSE_ACCOUNT,
  },
  {
    label: 'Assign Account',
    value: UserRolePermission.ASSIGN_ACCOUNT,
  },
  {
    label: 'Credit Refund Account',
    value: UserRolePermission.CREDIT_REFUND_ACCOUNT,
  },
  {
    label: 'View Leeloo Paid',
    value: UserRolePermission.VIEW_LEELOO_PAID,
  },
  {
    label: 'View Trader Paid',
    value: UserRolePermission.VIEW_TRADER_PAID,
  },
  {
    label: 'Edit Trades As Company',
    value: UserRolePermission.EDIT_TRADES_AS_COMPANY,
  },
  {
    label: 'Add Note',
    value: UserRolePermission.ADD_NOTE,
  },
  {
    label: 'Edit Own Note',
    value: UserRolePermission.EDIT_OWN_NOTE,
  },
  {
    label: 'Edit Any Note',
    value: UserRolePermission.EDIT_ANY_NOTE,
  },
  {
    label: 'Delete Note',
    value: UserRolePermission.DELETE_NOTE,
  },
  {
    label: 'View Purchase History',
    value: UserRolePermission.VIEW_PURCHASE_HISTORY,
  },
  {
    label: 'View Receipts',
    value: UserRolePermission.VIEW_RECEIPTS,
  },
  {
    label: 'View Payouts',
    value: UserRolePermission.VIEW_PAYOUTS,
  },
  {
    label: 'View Revenue',
    value: UserRolePermission.VIEW_REVENUE,
  },
  {
    label: 'Approve Payout',
    value: UserRolePermission.APPROVE_PAYOUT,
  },
  {
    label: 'Execute Payout',
    value: UserRolePermission.EXECUTE_PAYOUT,
  },
  {
    label: 'Create Discount Code',
    value: UserRolePermission.CREATE_DISCOUNT_CODE,
  },
  {
    label: 'Add Package',
    value: UserRolePermission.ADD_PACKAGE,
  },
  {
    label: 'View Reports',
    value: UserRolePermission.VIEW_REPORTS,
  },
  {
    label: 'Export Reports',
    value: UserRolePermission.EXPORT_REPORTS,
  },
  {
    label: 'Edit Email Templates',
    value: UserRolePermission.EDIT_EMAIL_TEMPLATES,
  },
  {
    label: 'Manage Users',
    value: UserRolePermission.MANAGE_USERS,
  },
  {
    label: 'Manage Roles',
    value: UserRolePermission.MANAGE_ROLES,
  },
  {
    label: 'Manage System Settings',
    value: UserRolePermission.MANAGE_SYSTEM_SETTINGS,
  },
  {
    label: 'Approve Evals',
    value: UserRolePermission.APPROVE_EVAL,
  },
  {
    label: 'Deny Evals',
    value: UserRolePermission.DENY_EVAL,
  },
  {
    label: 'Block Evals',
    value: UserRolePermission.BLOCK_EVAL,
  },
];

export const userTableData: TUserTable[] = [
  {
    id: '1',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '2',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Inactive,
  },
  {
    id: '3',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '4',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '5',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '6',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '7',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '8',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '9',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '10',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '11',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '12',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
  {
    id: '13',
    userNumber: 1,
    userName: 'joihndoe007',
    email: 'johnd@gmail.com',
    status: UserStatus.Active,
  },
];
